import { render, staticRenderFns } from "./JobTasks.vue?vue&type=template&id=36380d7f&scoped=true&"
import script from "./JobTasks.vue?vue&type=script&lang=js&"
export * from "./JobTasks.vue?vue&type=script&lang=js&"
import style0 from "./JobTasks.vue?vue&type=style&index=0&id=36380d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36380d7f",
  null
  
)

export default component.exports